import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

export interface SelectOption {
  value: string | number;
  label: string;
}

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrl: './custom-select.component.scss',
  standalone: false,
})
export class CustomSelectComponent {
  @Input() options: SelectOption[] = [];
  @Input() disabled: boolean = false;
  @Input() placeholder: string = '';
  @Output() valueChange = new EventEmitter<string | number>();
  @Input() selectedOption: string | number | null = null;
  dropdownOpen = false;

  @ViewChild('selectItems') selectItems!: ElementRef;
  @ViewChild('selectTrigger') selectTrigger!: ElementRef;

  positionClass: string = 'below'; // Default to 'below'

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.cdr.detectChanges(); // Ensures the view is fully initialized
  }

  toggleDropdown() {
    if (this.disabled) {
      return;
    }
    this.dropdownOpen = !this.dropdownOpen;
    this.cdr.detectChanges(); // Ensures the view is fully initialized
    if (this.dropdownOpen) {
      this.updateDropdownPosition();
    }
  }

  selectOption(option: SelectOption) {
    if (!this.disabled) {
      this.selectedOption = option.value;
      this.dropdownOpen = false;
      this.valueChange.emit(option.value);
    }
  }

  updateDropdownPosition() {
    const triggerRect =
      this.selectTrigger.nativeElement.getBoundingClientRect();
    const spaceBelow = window.innerHeight - triggerRect.bottom;
    const spaceAbove = triggerRect.top;

    // Determine where to open the dropdown based on available space
    this.positionClass =
      spaceBelow < this.selectItems.nativeElement.offsetHeight &&
      spaceAbove > spaceBelow
        ? 'above'
        : 'below';
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }
}
